import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {GetPreRegisterConsult} from 'domain/usecases/others/facial-biometric';
import {RemoteFacialBiometricGetPreRegisterConsult} from 'data/usecases/others/facial-biometric/request';
import {FacialBiometricEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetRequestFacialBiometricPreRegisterConsult = (): GetPreRegisterConsult =>
	new RemoteFacialBiometricGetPreRegisterConsult(
		makeBFFApiUrl(FacialBiometricEndpoints.preRegisterConsult),
		makeAuthorizeHttpClientDecorator(),
	);
